module.exports = __webpack_public_path__ + "img/CO.d1a61f94.svg";